import { authCookie } from '@/utils/auth'
import { getProviderData } from '@/utils/adyen'
import { BUNDLE_PRODUCT_CATEGORY, PLAN_PRODUCT_CATEGORY, NAUTA_PRODUCT_SUB_CATEGORY, CREDIT_PRODUCT_CATEGORY, SURVEY_MTU_CREDITS_SUB_CANCELLATION, SURVEY_MTU_PLANS_SUB_CANCELLATION, SURVEY_MTU_BUNDLES_SUB_CANCELLATION } from '@/utils/constants'

const addProductAndCheckout = (cookies, router, prop) => {
  cookies.set('selectedProduct', {
    id: prop.id,
    msisdn: prop.msisdn ? prop.msisdn : false,
    legacy: prop.legacy === true || false,
    addNewPayment: prop.addNewPayment === true || false,
    type: prop.type !== undefined ? prop.type : false,
    origin: prop.origin !== undefined ? prop.origin : null
  }, '7d', '/', process.env.COOKIE_DOMAIN)
  router.push({ 'name': 'CheckoutV2' })
}
const addProductAndCheckoutForTaf = (cookies, router, prop, routerParams) => {
  cookies.set('selectedProduct', {
    id: prop.id,
    msisdn: prop.msisdn ? prop.msisdn : false,
    legacy: prop.legacy === true || false,
    addNewPayment: prop.addNewPayment === true || false,
    type: prop.type !== undefined ? prop.type : false
  }, '7d', '/', process.env.COOKIE_DOMAIN)
  router.push({ 'name': 'CheckoutV2', params: routerParams })
}
const addProductAndCheckoutForNauta = (cookies, router, prop) => {
  cookies.set('selectedProduct', {
    id: prop.id,
    email: prop.email ? prop.email : false,
    legacy: prop.legacy === true || false,
    addNewPayment: prop.addNewPayment === true || false,
    type: prop.type !== undefined ? prop.type : false
  }, '7d', '/', process.env.COOKIE_DOMAIN)
  router.push({ 'name': 'CheckoutV2' })
}

const saveProductSearchCookie = (cookies, prop) => {
  cookies.set('savedProductSearch', {
    id: prop.id,
    msisdn: prop.msisdn ? prop.msisdn : false,
    countryId: prop.countryId ? prop.countryId : false,
    isMtu: prop.isMtu
  }, '1d', '/', process.env.COOKIE_DOMAIN)
}

const removeSelectProductCookie = (cookies) => {
  cookies.remove('selectedProduct', '/', process.env.COOKIE_DOMAIN)
}

const removeSavedProductSearchCookie = (cookies) => {
  cookies.remove('savedProductSearch', '/', process.env.COOKIE_DOMAIN)
}

const paymentMethodSfxClasses = () => {
  return {
    1: 'card-visa',
    2: 'card-mastercard',
    3: 'card-amex',
    4: 'card-diners',
    9: 'card-carte-bancaire',
    12: 'card-discover',
    13: 'card-japanese-credit-bank',
    77: 'card-china-unionpay',
    1001: 'card-paypal'
  }
}

const getAuthSession = () => {
  // Gets the session data
  return JSON.parse(decodeURIComponent(authCookie()))
}

// Load SEON - fraud detection, needed to construct the payment data
const initSEON = async () => {
  if (window.seon) {
    const session = getAuthSession()
    // https://docs.seon.io/api-reference#javascript-agent-v5
    window.seon.config({
      host: 'seondf.com',
      session_id: session.sessionId,
      audio_fingerprint: false,
      canvas_fingerprint: true,
      webgl_fingerprint: true,
      onError: function (message) {
        console.error(message)
      }
    })
  }
}

// gets the SEON session data that makes a call to get security data that the backend can validate to detect possible fraud
const getSEONSessionData = async () => {
  return new Promise((resolve, reject) => {
    if (window.seon) {
      window.seon.getBase64Session((base64sessionData) => {
        if (base64sessionData) {
          resolve(base64sessionData)
        } else {
          reject(Error('Failed to retrieve session data.'))
        }
      })
    }
  })
}

// Construct the payment data needed to submit a payment
const constructPaymentData = async (data) => {
  return new Promise((resolve, reject) => {
    getSEONSessionData()
      .then((sessionData) => {
        const paymentData = {
          email: data.userEmail,
          providerData: null
        }
        const session = getAuthSession()
        paymentData.sessionData = sessionData
        paymentData.sessionDataId = session.sessionId

        resolve(paymentData)
      })
      .catch(() => {
        reject(Error('Failed to retrieve session data.'))
      })
  })
}

// Construct the payment data needed to submit a payment
const constructProviderData = (data) => {
  // Gets the url that we will be redirected to after the payment needed in the providerData
  const resolved = data.router.resolve({
    name: data.routeTo,
    params: {
      locale: data.locale,
      id: 'TEMP'
    }
  })
  const redirectUrl = window.location.origin + resolved.href.replace('TEMP', '').replace('//', '')
  // Provider data contains brower info and user info and is send to the payment provider
  return JSON.stringify(getProviderData(data.email, data.locale, redirectUrl, data.payload))
}

const isPlanProduct = (product) => {
  return product.productCategory === BUNDLE_PRODUCT_CATEGORY && product.productSubCategory === PLAN_PRODUCT_CATEGORY
}
const isBundleProduct = (product) => {
  return product.productCategory === BUNDLE_PRODUCT_CATEGORY && product.productSubCategory !== PLAN_PRODUCT_CATEGORY
}
const isNautaProduct = (product) => {
  return product.productCategory === BUNDLE_PRODUCT_CATEGORY && product.productSubCategory === NAUTA_PRODUCT_SUB_CATEGORY
}
const getMTUCategoryStringForMParticle = (product) => {
  if (product.productCategory === BUNDLE_PRODUCT_CATEGORY) {
    return 'Plans & Bundles'
  } else {
    return 'Credits'
  }
}
const getMTUSubCategoryStringForMParticle = (product) => {
  if (product.productCategory !== BUNDLE_PRODUCT_CATEGORY) { // No sub category for credits
    return null
  }
  if (product.productSubCategory === NAUTA_PRODUCT_SUB_CATEGORY) {
    return 'Nauta'
  } else if (product.productSubCategory === PLAN_PRODUCT_CATEGORY) {
    return 'Plan'
  } else {
    return 'Bundles'
  }
}
const getCallingSubCategoryStringForMParticle = (callingProduct) => {
  if (callingProduct.name === 'Rebtel Credits') {
    return 'Credits'
  } else if (callingProduct.name.toLowerCase().includes('unlimited')) {
    return 'Unlimited'
  } else {
    return 'Limited'
  }
}
const getCallingCategoryStringForMParticle = (callingProduct) => {
  if (callingProduct.name === 'Rebtel Credits') {
    return 'World Credits'
  } else {
    return 'Subscription'
  }
}
const getSubCategoryStringForCancelSurvey = (product) => {
  if (product.productCategory === CREDIT_PRODUCT_CATEGORY) { // No sub category for credits
    return SURVEY_MTU_CREDITS_SUB_CANCELLATION
  }
  if (product.productSubCategory === PLAN_PRODUCT_CATEGORY) {
    return SURVEY_MTU_PLANS_SUB_CANCELLATION
  } else {
    return SURVEY_MTU_BUNDLES_SUB_CANCELLATION
  }
}
export {
  getAuthSession,
  initSEON,
  getSEONSessionData,
  addProductAndCheckout,
  removeSelectProductCookie,
  paymentMethodSfxClasses,
  constructPaymentData,
  constructProviderData,
  addProductAndCheckoutForNauta,
  isPlanProduct,
  isBundleProduct,
  isNautaProduct,
  getMTUCategoryStringForMParticle,
  getMTUSubCategoryStringForMParticle,
  removeSavedProductSearchCookie,
  saveProductSearchCookie,
  getSubCategoryStringForCancelSurvey,
  addProductAndCheckoutForTaf,
  getCallingSubCategoryStringForMParticle,
  getCallingCategoryStringForMParticle
}



// WEBPACK FOOTER //
// ./src/utils/checkout.js